import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Box,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import HeresAmericaService from "../../../../../../services/HA/HeresAmericaService";
import {
  displaySuccessToast,
  displayErrorToast,
} from "../../../../../../utils/toast";

export default function MediaUploader({
  questionIndex,
  answerIndex,
  onMediaUpdate,
  media,
  disabled,
  bookId,
}) {
  const [mediaUrl, setMediaUrl] = useState("");
  const [mediaType, setMediaType] = useState("image");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (media) {
      setMediaUrl(media.url || "");
      setMediaType(media.type || "image");
    }
  }, [media]);

  useEffect(() => {
    console.log({
      questionIndex,
      answerIndex,
      onMediaUpdate,
      media,
      disabled,
      bookId,
    });
  }, [questionIndex, answerIndex, onMediaUpdate, media, disabled, bookId]);

  const handleInputChange = (e) => {
    setMediaUrl(e.target.value);
  };

  const handleMediaTypeChange = (e) => {
    setMediaType(e.target.value);
  };

  const handleUpdateClick = () => {
    if (mediaUrl.trim()) {
      onMediaUpdate(questionIndex, answerIndex, mediaUrl, mediaType);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!file || !bookId) {
      setMessage("Please provide a file and book ID.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("bookId", bookId);

    try {
      const res = await HeresAmericaService.uploadMediaForQuiz(formData);
      if (res) {
        displaySuccessToast(`File uploaded successfully: ${res.url}`);
        setMessage(`File uploaded successfully: ${res.url}`);
        onMediaUpdate(questionIndex, answerIndex, res.url, mediaType);
      } else {
        setMessage(`Upload failed: ${res.error}`);
      }
    } catch (error) {
      displayErrorToast(error.message);
      setMessage(`Upload error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6">Add Media</Typography>
      <Box mb={2}>
        <TextField
          fullWidth
          disabled={disabled}
          type="text"
          value={mediaUrl}
          onChange={handleInputChange}
          placeholder={`Enter ${mediaType === "image" ? "image" : "video"} URL`}
          variant="outlined"
        />
      </Box>
      <FormControl fullWidth variant="outlined" mb={2}>
        <InputLabel>Media Type</InputLabel>
        <Select
          value={mediaType}
          onChange={handleMediaTypeChange}
          disabled={disabled}
          label="Media Type"
        >
          <MenuItem value="image">Image</MenuItem>
          <MenuItem value="video">Video</MenuItem>
        </Select>
      </FormControl>
      <Box mb={2}>
        <Button
          variant="contained"
          color="primary"
          disabled={disabled || isLoading}
          onClick={handleUpdateClick}
        >
          {isLoading ? (
            <CircularProgress size={24} color="primary" />
          ) : (
            "Update Media"
          )}
        </Button>
      </Box>
      <Box mb={2}>
        <input
          type="file"
          onChange={handleFileChange}
          disabled={disabled}
          //   style={{ display: "none" }}
          id="upload-file-input"
        />
        {/* <label htmlFor="upload-file-input">
          <Button
            variant="contained"
            color="secondary"
            component="span"
            disabled={disabled}
          >
            Upload File
          </Button>
        </label> */}
      </Box>
      {file && (
        <Box mb={2}>
          <Typography variant="body1">Selected file: {file.name}</Typography>
        </Box>
      )}
      {file && (
        <Box mb={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={disabled || isLoading}
          >
            {isLoading ? (
              <CircularProgress size={24} color="primary" />
            ) : (
              "Submit File"
            )}
          </Button>
        </Box>
      )}
      {message && (
        <Box mt={2}>
          <Typography variant="body1">{message}</Typography>
        </Box>
      )}
    </Box>
  );
}
